import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import {
    DropZone,
    LegacyStack,
    Thumbnail,
    LegacyCard,
    Text,
    Spinner,
    TextField,
} from '@shopify/polaris';
import { NoteIcon } from '@shopify/polaris-icons';
import { Modal } from '@mui/material';
import { cross } from '../../../assets';
import { Visibility } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { getAppOverViewDetails, saveconfigurationsApi, uploadBannerApi, uploadImageApi } from '../../dev_services/developer/api';
import { fetchDataSuccess } from '../../dev_store/slice/apps_overview_slice/apps_overview_slice';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const DevUploadBanner: React.FC<DevUploadBannerProps> = ({ open, onClose }) => {
    const [files, setFiles] = useState<File[]>([]);
    const [loading, setLoading] = useState(false); 
    const [title, setTitle] = useState(""); // Add state for title
    const { appID } = useParams();
    const dispatch = useDispatch();
    

    const handleDropZoneDrop = useCallback(
        (_dropFiles: File[], acceptedFiles: File[], _rejectedFiles: File[]) =>
            setFiles((files) => [...files, ...acceptedFiles]),
        [],
    );


    const handleSaveIconClick = async () => {
        try {
            setLoading(true); 
    
            // Call the uploadImageApi function with the files
            const response = await uploadImageApi(files);
            
            if(response){
                
                // toast.success("Image uploaded successfully.");
                try{
                    const appIconUrl = response; // Assuming 'response' contains the app_icon object with the app_id property
                    const sendData = {
                        list_of_banners: [
                            {
                                title: title, // Use the title from state
                                url: appIconUrl
                            }
                        ],
                        // app_id: appID
                    };
                    ///save image on s3 bucket server
                    const saveResponse = await uploadBannerApi(appID,sendData);
              
                    ///fect new update changes
                    const responseUpdate = await getAppOverViewDetails(appID);
                    const slugName = responseUpdate.slug;
                    localStorage.setItem('slug', slugName);
                    dispatch(fetchDataSuccess(responseUpdate));
                    onClose()
                } catch(error){
                    toast.error("Image Not upload ");
                }
            }
            
        } catch (error) {
            console.error("Error uploading image:", error);
            toast.error("Error uploading image");
        }
        finally{
            setLoading(false); 
        }
    };

    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

    const fileUpload = !files.length && (
        <div style={{
            display: "ruby-text",
            paddingTop: "40px", fontFamily: "sfprobold",fontSize:"22px"
        }}>
            <Text variant="bodySm" as="h1">Upload Banner</Text>
        </div>
    );

    const uploadedFiles =
        files.length > 0 && (
            <>
                {files.map((file, index) => (
                    <LegacyStack alignment="center" key={index}>
                        <Thumbnail
                            size="small"
                            alt={file.name}
                            source={
                                validImageTypes.includes(file.type)
                                    ? window.URL.createObjectURL(file)
                                    : NoteIcon
                            }
                        />
                        <div>
                            {file.name}{' '}
                            <Text variant="bodySm" as="p">
                                {file.size} bytes
                            </Text>
                        </div>
                    </LegacyStack>
                ))}
            </>
        );

    
    return (
        <Modal  open={open} onClose={onClose}>
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    padding: '20px',
                    outline: 'none',
                    borderRadius: '10px',
                    // Add relative positioning
                }}
            >
                {/* Position the close icon at the top-right corner */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        padding: '5px',
                    }}
                >
                    <img
                        style={{ width: '40px', cursor: 'pointer' }}
                        src={cross}
                        alt="Close Icon"
                        onClick={onClose}
                    />
                </div>
                <div style={{ width: "300px", padding: "20px", pointerEvents: files.length === 1 ? "none" : "visible" }}>
                    <DropZone outline={true} onDrop={handleDropZoneDrop}>
                        {uploadedFiles}
                        {fileUpload}
                    </DropZone>
                   
                </div>
                <div style={{marginTop:"10px"}}>
                        <TextField
                            label="Image Title"
                            autoComplete=''
                            placeholder="Enter image Title"
                            multiline={1}
                            value={title} // Bind value to state
                            onChange={(newValue) => setTitle(newValue)} // Update title state on change
                        />
                    </div>
                {files.length > 0 && (
                    <div style={{
                        paddingTop: " 20px",
                        textAlignLast: "center"
                    }}>
                        {loading ? (
                            <div className="container" style={{paddingLeft:"130px"}}>
                                <Spinner size='small'></Spinner>
                            </div>
                        ) : (
                            <button
                                disabled={!title} // Disable button if title is empty
                                style={{
                                    border: '1px solid grey', // Grey border
                                    borderRadius: '4px', // Rectangle border
                                    padding: '10px 20px', // Adjust padding as needed
                                    backgroundColor: 'transparent', // Transparent background
                                    color: '#333', // Text color
                                    cursor: 'pointer', // Show pointer cursor on hover
                                    outline: 'none', // Remove default button outline
                                }}
                                onClick={handleSaveIconClick} // Call handleSaveIconClick when the button is clicked
                            >
                                Save Banner
                            </button>
                        )}
                    </div>
                )}
            </div>
        </Modal>
    );
};

// Define PropTypes for the component
interface DevUploadBannerProps {
    open: boolean;
    onClose: () => void;
    // Add any other props you need
}

export default DevUploadBanner;
